import React from 'react';
import { useNavigate } from 'react-router-dom';

/** Sticky sub-page header with a back arrow (navigate(-1)) — used on every non-home route. */
export default function PageHeader({ title, sub, right, fallback = '/' }) {
  const navigate = useNavigate();
  const goBack = () => {
    if (window.history.state && window.history.state.idx > 0) navigate(-1);
    else navigate(fallback);
  };
  return (
    <div className="sticky top-14 md:top-[76px] z-30 bg-paper/95 backdrop-blur border-b border-black/5 shadow-soft">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-3.5 flex items-center gap-3">
        <button
          type="button"
          onClick={goBack}
          aria-label="Back"
          className="h-9 w-9 shrink-0 rounded-full bg-white border border-black/5 shadow-soft flex items-center justify-center text-brand-dark font-black hover:bg-brand-light/60"
        >
          ‹
        </button>
        <div className="min-w-0 flex-1">
          <div className="font-black text-[17px] text-brand-dark truncate">{title}</div>
          {sub ? <div className="text-xs text-ink-faint truncate">{sub}</div> : null}
        </div>
        {right}
      </div>
    </div>
  );
}
